import { Angulartics2 } from '@angularticsCompat';
import { BehaviorSubject } from 'rxjs';
import { SetupGuideGoToSection, SetupGuideLinkTrackingParams } from '../../connector/connector-form/interfaces/setupGuideLink';


export let _setupGuideCommService: SetupGuideCommService;

export class SetupGuideCommService {
  static deps = [Angulartics2];

  private _goToSection$ = new BehaviorSubject<SetupGuideGoToSection>({
    link: null
  });

  goToSection$ = this._goToSection$.asObservable();

  constructor(private _angulartics2: Angulartics2) {
    _setupGuideCommService = this;
  }

  goToSection(
    link: string,
    trackingParams?: SetupGuideLinkTrackingParams,
    scrollOffset?: number,
    highlightTitle?: boolean,
  ): void {
    const scrollStrategy = trackingParams.scrollStrategy || 'auto';

    this._angulartics2.eventTrack.next({
      action: '[SBS Docs] navigate to section',
      properties: trackingParams ? {
        sourceSection: trackingParams.sourceSection,
        medium: trackingParams.medium,
        label: trackingParams.label,
        scrollStrategy: scrollStrategy,
        ...(trackingParams.properties || {})
      } : null
    });

    this._goToSection$.next({
      link,
      scrollStrategy,
      scrollOffset,
      highlightTitle,
    });
  }
}
